module.exports = __webpack_public_path__ + "img/hiddenRisk_checked.488688c8.png";